import { memo } from 'react';
import { Box, Divider } from '@material-ui/core';
import { SETVIImage, SText } from '@setvi/shared/components';

interface GridCardFooterProps {
  iconUrl: string;
  fileName: string;
  actions?: JSX.Element;
}

export const GridCardFooter = memo(
  ({ iconUrl, fileName, actions }: GridCardFooterProps) => (
    <Box>
      <Divider />
      <Box
        mt={2}
        height={40}
        display="flex"
        justifyContent="center"
        alignItems="center">
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          width="100%">
          <Box display="flex" alignItems="center" flex={1}>
            <SETVIImage src={iconUrl} alt="File Type" width={21} />
            <Box ml={2}>
              <SText
                title={fileName}
                fontColor="#5D7083"
                size="xs"
                weight="medium"
              />
            </Box>
          </Box>
          {actions}
        </Box>
      </Box>
    </Box>
  )
);
